<template>
  <div class="mode-toggle">
    <div class="mode-title">
      Активный режим:
    </div>

    <div class="mode-controls">
      <div class="mode-side left">
        <img
            class="mode-icon"
            src="@/assets/images/mood_tracker/graduation-hat.png"
            alt="Обучение"
        />
        <span class="mode-label">обучение</span>

        <button
            class="info-btn"
            type="button"
            @click="togglePopup('test')"
        >
          ?
        </button>

        <div v-if="openedPopup === 'test'" class="info-popup left-popup">
          <p class="popup-text">
            {{ popupTexts.test.default.text }}
          </p>

          <ul
              v-if="popupTexts.test.default.list.length"
              class="popup-list"
          >
            <li
                v-for="(item, index) in popupTexts.test.default.list"
                :key="index"
            >
              {{ item }}
            </li>
          </ul>
        </div>
      </div>

      <label class="switch">
        <input
            type="checkbox"
            v-model="isWorkMode"
        />
        <span class="slider"></span>
      </label>

      <div class="mode-side right">
        <button
            class="info-btn"
            type="button"
            @click="togglePopup('work')"
        >
          ?
        </button>

        <img
            class="mode-icon"
            src="@/assets/images/mood_tracker/work-case.svg"
            alt="Рабочий режим"
        />
        <span class="mode-label">рабочий</span>

        <div v-if="openedPopup === 'work'" class="info-popup right-popup">
          <p class="popup-text">
            {{ popupTexts.work.default.text }}
          </p>

          <ul
              v-if="popupTexts.work.default.list.length"
              class="popup-list"
          >
            <li
                v-for="(item, index) in popupTexts.work.default.list"
                :key="index"
            >
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, onMounted, onBeforeUnmount } from 'vue'
import {useStore} from "vuex";
import {watch} from "@vue/runtime-core";
import {notify} from "@kyvg/vue3-notification";

export default {
  name: 'ModeControl',
  props: {
    type: {
      type: String,
      default: 'test',
    },
  },

  setup(props) {
    const isWorkMode = ref(props.type === 'work');
    const openedPopup = ref(null);
    const store = useStore();

    const popupTexts = {
      test: {
        default: {
          text: 'Идеален для новых пользователей и тех, кто хочет освоить функционал инструмента.',
          list: [
            'Появляются подсказки и интерактивные туториалы',
            'Ошибки не влияют на аналитику — можно экспериментировать без риска',
          ],
        },
      },
      work: {
        default: {
          text: 'Полноценный рабочий режим инструмента для выполнения реальных задач.',
          list: [
            'Все действия влияют на процессы и аналитику',
            'Доступны все инструменты и интеграции',
            'Подсказки скрыты (их можно включить в настройках)'
          ],
        },
      },
    }

    const notificationMessages = {
      work: 'Переключено в режим работы. Все действия теперь влияют на аналитику',
      test: 'Переключено в режим обучения'
    }

    const togglePopup = (name) => {
      openedPopup.value = openedPopup.value === name ? null : name;
    }

    const handleClickOutside = (event) => {
      const root = event.target.closest('.mode-toggle')

      if (!root) {
        openedPopup.value = null
      }
    }

    onMounted(() => {
      document.addEventListener('click', handleClickOutside)
    })

    onBeforeUnmount(() => {
      document.removeEventListener('click', handleClickOutside)
    })

    watch(() => isWorkMode.value, () => {
      store.dispatch('tracker/setCurrentSettings', {mode: isWorkMode.value ? 'work' : 'test'}).then(() => {
        store.dispatch('tracker/getCurrentSettings');

        notify({
          type: "info",
          title: notificationMessages[isWorkMode.value ? 'work' : 'test'],
        });
      });
    });

    return {
      isWorkMode,
      openedPopup,
      popupTexts,
      togglePopup,
    }
  },
}
</script>

<style scoped>
.mode-toggle {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 14px;
  background: #e5e5e5;
  border-radius: 18px;
  padding: 8px 16px;
  font-family: Arial, sans-serif;
  color: #222;
  font-size: 18px;
  line-height: 1;

  @media (max-width: 930px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}

.mode-title {
  white-space: nowrap;
}

.mode-controls {
  display: flex;
  align-items: center;
  gap: 14px;
  white-space: nowrap;

  @media (max-width: 930px) {
    flex-wrap: nowrap;
  }
}

.mode-side {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
}

.mode-label {
  white-space: nowrap;
}

.mode-icon {
  font-size: 18px;
  display: inline-flex;
  align-items: center;
}

.info-btn {
  width: 16px;
  height: 16px;
  border: none;
  border-radius: 50%;
  background: #cfcfcf;
  color: #666;
  font-size: 11px;
  line-height: 16px;
  text-align: center;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
}

.info-btn:hover {
  background: #bdbdbd;
}

.switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 22px;
  flex-shrink: 0;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  inset: 0;
  background: #c8c8c8;
  border-radius: 999px;
  transition: 0.25s;
  cursor: pointer;
}

.slider::before {
  content: '';
  position: absolute;
  width: 18px;
  height: 18px;
  left: 2px;
  top: 2px;
  background: white;
  border-radius: 50%;
  transition: 0.25s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
}

.switch input:checked + .slider::before {
  transform: translateX(20px);
}

.info-popup {
  position: absolute;
  top: calc(100% + 10px);
  min-width: 220px;
  max-width: 300px;
  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  line-height: 1.35;
  color: #333;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  z-index: 20;
  white-space: normal;
  word-break: break-word;
}

.left-popup {
  left: 0;
}

.right-popup {
  right: 0;
}

.popup-text {
  margin: 0 0 8px;
  font-size: 14px;
  line-height: 1.4;
}

.popup-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.popup-list li {
  position: relative;
  padding-left: 16px;
  margin-bottom: 6px;
  font-size: 14px;
  line-height: 1.4;
}

.popup-list li::before {
  content: '→';
  position: absolute;
  left: 0;
  top: 0;
}

.mode-icon {
  width: 18px;
  height: 18px;
  display: block;
  flex-shrink: 0;
  object-fit: contain;
}
</style>